import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { createStore, select, setProp, withProps } from '@ngneat/elf';
import { UserDTO } from 'src/classes/userDTO';

export interface UserProps {
  User?: UserDTO;
}

const store = createStore({ name: 'user' }, withProps<UserProps>({}));

@Injectable({ providedIn: 'root' })
export class UserRepository {
  setUser(user: UserDTO): void {
    store.update(setProp('User', user));
  }

  getUser$(): Observable<UserDTO | undefined> {
    return store.pipe(select((state) => state.User));
  }

  clearUser() {
    store.reset();
  }
}
